module.exports = __webpack_public_path__ + "img/live-casino.761f895.png";